module.exports = __webpack_public_path__ + "assets/img/btn-view-5ca3135a.png";